/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'gslb';

export const gslbSubdomainBreadcrumbTitle = `${prefix}.gslbSubdomainBreadcrumbTitle`;

export const ENGLISH = {
    [gslbSubdomainBreadcrumbTitle]: 'Subdomain',
};
